import React from 'react';
import { BentoCard } from './BentoCard';
import { OrangeAccent } from './OrangeAccent';
interface CaseStudy {
  location: string;
  headline: string;
  tagline: string;
  cards: {
    title: string;
    value: string;
    subtitle: string;
    span: 1 | 2;
  }[];
}
const CASE_STUDIES: CaseStudy[] = [{
  location: 'HAWAII',
  headline: 'Hawaii Clinic',
  tagline: 'From cold start to fully booked in days',
  cards: [{
    title: 'Visits Booked in 72 Hours',
    value: '61',
    subtitle: 'Zero additional ad spend during launch week',
    span: 2
  }, {
    title: 'New Cash Added in 5 Months',
    value: '$200,000+',
    subtitle: 'From one system, not 5 vendors',
    span: 1
  }, {
    title: 'Time Investment per Month',
    value: '1 hr',
    subtitle: 'On Zoom recording your story',
    span: 1
  }, {
    title: 'Reactivation Conversion',
    value: '92%',
    subtitle: 'Of contacted dormant patients re-engaged',
    span: 2
  }]
}, {
  location: 'CALIFORNIA',
  headline: 'California Clinic',
  tagline: 'Built a steady $20K/month reactivation engine',
  cards: [{
    title: 'Cash Collected in Week 1',
    value: '$11,000',
    subtitle: 'Direct from reactivation campaigns',
    span: 2
  }, {
    title: 'Average New Cash per Month',
    value: '$20,000+',
    subtitle: 'For 12 consecutive months',
    span: 1
  }, {
    title: 'Front Desk Workload Added',
    value: '0 hrs',
    subtitle: 'Appointment center handles confirmations',
    span: 1
  }, {
    title: 'Patient Show Rate',
    value: '78%',
    subtitle: 'Up from clinic baseline of 52%',
    span: 2
  }]
}, {
  location: 'FLORIDA',
  headline: 'Florida Clinic',
  tagline: '30 days from $117K/mo to $144K/mo',
  cards: [{
    title: 'Monthly Revenue Lift in 30 Days',
    value: '$27,000',
    subtitle: 'Added on top of existing baseline',
    span: 2
  }, {
    title: 'Starting Monthly Revenue',
    value: '$117,000',
    subtitle: 'Where they were when we installed',
    span: 1
  }, {
    title: 'New Monthly Revenue',
    value: '$144,000',
    subtitle: 'Where they were 30 days later',
    span: 1
  }, {
    title: 'Conversion to Care Plan',
    value: '67%',
    subtitle: 'Of new patient visits booked into plans',
    span: 2
  }]
}, {
  location: 'TEXAS',
  headline: 'Texas Clinic',
  tagline: '41 consults + 25% retention bump in 30 days',
  cards: [{
    title: 'Consults Booked in First 30 Days',
    value: '41',
    subtitle: 'All filtered + confirmed before arrival',
    span: 2
  }, {
    title: 'Patient Retention Increase',
    value: '25%+',
    subtitle: 'After installing nurture sequences',
    span: 1
  }, {
    title: 'Ad Channels Required',
    value: '1',
    subtitle: 'Down from 4 disconnected vendors',
    span: 1
  }, {
    title: 'Months to Full ROI',
    value: '2',
    subtitle: 'Self-funding after month 2',
    span: 2
  }]
}];
export function StatsSection() {
  return <section id="proof" className="w-full scroll-mt-20 py-20 md:py-28 px-4" data-id="element-123">
      <div className="max-w-[1100px] mx-auto" data-id="element-124">
        <h2 className="font-display font-extrabold text-ink text-center leading-[1.1]" style={{
        fontSize: 'clamp(28px, 4vw, 44px)',
        letterSpacing: '-.02em'
      }} data-id="element-125">
          Case <span className="text-orange" data-id="element-126">Studies</span>
        </h2>
        <div className="flex justify-center mt-3 mb-20" data-id="element-127">
          <OrangeAccent data-id="element-128" />
        </div>

        <div className="flex flex-col gap-[60px]" data-id="element-129">
          {CASE_STUDIES.map(study => <div key={study.location} className="w-full" data-id="element-130">
              <div className="flex flex-col items-center text-center mb-8" data-id="element-131">
                <h3 className="font-display font-bold text-ink leading-tight" style={{
              fontSize: 'clamp(22px, 3vw, 32px)',
              letterSpacing: '-.02em'
            }} data-id="element-132">
                  {study.headline}
                </h3>
                <p className="font-sans font-medium text-[16px] text-ink-soft mt-2 max-w-[560px]" data-id="element-133">
                  {study.tagline}
                </p>
                <OrangeAccent className="mt-4" data-id="element-134" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5" data-id="element-135">
                {study.cards.map((card, i) => <BentoCard key={`${study.location}-${card.title}`} title={card.title} value={card.value} subtitle={card.subtitle} delay={i} className={card.span === 2 ? 'md:col-span-2' : 'md:col-span-1'} data-id="element-136" />)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}